var map = {
	"./asegrup.png": "01c8",
	"./it_slider_power.png": "5d00",
	"./mx_slider_power.png": "72a9",
	"./pt_slider_power.png": "e8ce",
	"./slide_extensiondegarantia.jpg": "0913",
	"./slide_movil.jpg": "94ea",
	"./slide_movil_vector": "8938",
	"./slide_movil_vector.json": "8938",
	"./slide_multidispositivo.jpg": "2134",
	"./slide_patinete.jpg": "ee35",
	"./slide_portatil.jpg": "eda4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81ad";